import React, {useContext} from "react";

export const EnabledFeaturesContext = React.createContext<
  Record<string, boolean>
>({});

export const useEnabledFeatures = () => useContext(EnabledFeaturesContext);
